/**
 * Display label for a non-project category's type. One source so the timesheet
 * tag and the admin Categories pane cannot drift apart again.
 */
export type CategoryTypeLabel = 'Indirect' | 'Leave';

export function categoryTypeLabel(isWorkTime: boolean): CategoryTypeLabel {
  return isWorkTime ? 'Indirect' : 'Leave';
}
